module.exports = __webpack_public_path__ + "img/brush_0.0c76994f.png";